<template>
  <DashboardIndex activeViewName="calendar" v-bind="$attrs" ></DashboardIndex>
</template>

<script>
import DashboardIndex from "../../modules/dashboard/components/DashboardIndex.vue";
export default {
  name: "Calendar",
  components: {
    DashboardIndex
  },
  method: {

  },
  mounted() {
    var maxTime = 7500, //maximum time for checking #calendar-content is visible
        startTime = Date.now()
    var interval = setInterval(function () {
          if ($('#calendar-content')
              .is(':visible')) {
            window.runCalendar()
            clearInterval(interval)
          } else if (Date.now() - startTime > maxTime) {
            clearInterval(interval)
            alert('Er is een probleem opgetreden bij het laden van de agenda')
          }
        },
        100 // 0.1 second (wait time between checks)
    )
    this.$mount('#page-wrapper')
  }
};
</script>

<style scoped>

</style>
